import React from 'react'
// libs
import { FieldArray, InjectedFormProps, reduxForm } from 'redux-form'
// constants
import { AVAILABLE_TO } from 'constants/security'
import { ENTITIES, Forms } from 'constants/index'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import renderUsers from 'components/FormElements/UsersList'
// types
import { IOption } from 'components/FormElements/Select'
// views
import { Form, ButtonsWrapper } from './views'

interface IIncomingProps {
  hideModal: () => void
}

interface IFormData {
  name: string
}

type IFormProps = InjectedFormProps<IFormData, IIncomingProps>

type IProps = IIncomingProps & IFormProps

const ReportForm: React.FC<IProps> = ({ handleSubmit, submitting, hideModal }) => {
  const prepareOptions = (options: (IOption & { entity: keyof typeof ENTITIES })[]) => {
    return [
      { label: '(All Users)', value: AVAILABLE_TO.ALL },
      { label: '(Managers)', value: AVAILABLE_TO.MANAGERS },
      ...options
        .filter((item) => item.entity === ENTITIES.USER)
        .map((item) => ({
          value: item.value,
          label: item.label
        }))
    ]
  }

  return (
    <Form onSubmit={handleSubmit}>
      <FieldArray name='availableTo' component={renderUsers} prepareOptions={prepareOptions} />
      <ButtonsWrapper>
        <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE} shadowLess isLoading={submitting}>
          Save
        </Button>
        <Button type={'button'} onClick={hideModal} layout={BUTTON_LAYOUTS.PURPLE_INVERTED} shadowLess>
          Cancel
        </Button>
      </ButtonsWrapper>
    </Form>
  )
}

export default reduxForm<IFormData, IIncomingProps>({
  form: Forms.REPORT_PERMISSIONS_FORM,
  enableReinitialize: true
})(ReportForm)
